<template>
    <el-dialog v-model="data.currentImageVisible"><img style="width:100%" :src="data.currentImage[0].url"
            alt="预览图" /></el-dialog>
    <el-dialog title="修改服设信息" v-model="data.editVisible">
        <el-form :model="editInfo" :inline="true">
            <el-form-item label="上传图片">
                <el-upload action="https://run.mocky.io/v3/9d059bf9-4660-45f2-925d-ce80ad6c4d15"
                    accept=".jpeg,.png,.jpg" list-type="picture-card" :on-preview="handlePreview"
                    :on-remove="handleRemove" :auto-upload="false" :on-change="handleFileChange"
                    :file-list="data.currentImage" :limit="1">
                    <el-icon>
                        <Plus />
                    </el-icon>
                </el-upload>
            </el-form-item>
            <el-form-item label="编号">
                <el-input v-model="editInfo.id" />
            </el-form-item>
            <el-form-item label="排序">
                <el-input v-model="editInfo.sort" />
            </el-form-item>
            <el-form-item label="关联角色">
                <el-input v-model="editInfo.charaId" />
            </el-form-item>
            <el-form-item label="年龄">
                <el-input v-model="editInfo.age" />
            </el-form-item>
            <el-form-item label="服设">
                <el-input v-model="editInfo.name" />
            </el-form-item>
            <el-form-item label="差分">
                <el-input v-model="editInfo.diff" />
            </el-form-item>
            <el-form-item label="描述">
                <el-input v-model="editInfo.description" />
            </el-form-item>
            <el-form-item label="更新时间">
                <el-input v-model="editInfo.updateTime" disabled />
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit" :loading="data.loading">保存</el-button>
                <el-button @click="cancel">取消</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
    <el-dialog title="新增服设信息" v-model="data.createVisible">
        <el-form :model="editInfo" :inline="true">
            <el-form-item label="上传图片">
                <el-upload action="https://run.mocky.io/v3/9d059bf9-4660-45f2-925d-ce80ad6c4d15"
                    accept=".jpeg,.png,.jpg" list-type="picture-card" :on-preview="handlePreview"
                    :on-remove="handleRemove" :auto-upload="false" :on-change="handleFileChange"
                    :file-list="data.currentImage" :limit="1">
                    <el-icon>
                        <Plus />
                    </el-icon>
                </el-upload>
            </el-form-item>
            <el-form-item label="编号">
                <el-input v-model="editInfo.id" />
            </el-form-item>
            <el-form-item label="排序">
                <el-input v-model="editInfo.sort" />
            </el-form-item>
            <el-form-item label="关联角色">
                <el-input v-model="editInfo.charaId" />
            </el-form-item>
            <el-form-item label="年龄">
                <el-input v-model="editInfo.age" />
            </el-form-item>
            <el-form-item label="服设">
                <el-input v-model="editInfo.name" />
            </el-form-item>
            <el-form-item label="差分">
                <el-input v-model="editInfo.diff" />
            </el-form-item>
            <el-form-item label="描述">
                <el-input v-model="editInfo.description" />
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit" :loading="data.loading">保存</el-button>
                <el-button @click="cancel">取消</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
    <el-dialog title="删除稿件信息" v-model="data.deleteVisible">
        <el-form :model="editInfo" :inline="true">
            <el-form-item>
                是否删除相关稿件信息？
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit" :loading="data.loading">确认</el-button>
                <el-button @click="cancel">取消</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
    <el-button type="primary" @click="handleCreate">新增</el-button>
    <el-input v-model="input" style="width: 200px" placeholder="按照角色名查询" />
    <el-button type="primary" @click="handleSearch"><i class="fa fa-search" /></el-button>
    <!-- <div>
        <el-checkbox v-model="data.checkAll" :indeterminate="data.isIndeterminate" @change="handleCheckAllChange">
            展示全部
        </el-checkbox>
        <el-checkbox-group v-model="data.checkedCharas" @change="handleCheckedChange">
            <el-checkbox v-for="name, id in closet.charaNameList" :key="id" :label="id">
                {{ name }}
            </el-checkbox>
        </el-checkbox-group>
    </div> -->
    <div v-if="closetList.closetInfo != null">
        <el-table :data="closetList.closetInfo" stripe border v-if="closetList">
            <el-table-column show-overflow-tooltip prop="id" label="编号" />
            <el-table-column show-overflow-tooltip label="图片预览">
                <template #default="scope">
                    <el-image style="width: 100%" :src="'http://img.helloworldend.top/closet/' + scope.row.image"
                        show-progress fit="cover" />
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="sort" label="排序" />
            <el-table-column show-overflow-tooltip label="关联角色">
                <template #default="scope">
                    {{ charaNameList[scope.row.charaId] ||
                        `(${scope.row.charaId})` }}
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="age" label="年龄" />
            <el-table-column show-overflow-tooltip prop="name" label="服设" />
            <el-table-column show-overflow-tooltip prop="diff" label="差分" />
            <el-table-column show-overflow-tooltip prop="description" label="描述" />
            <el-table-column show-overflow-tooltip prop="status" label="状态" />
            <el-table-column show-overflow-tooltip prop="updateTime" label="更新时间" />
            <el-table-column label="操作" fixed="right" width="250">
                <template #default="scope">
                    <el-button type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                    <el-button type="default" @click="handleEnable(scope.$index, scope.row)">{{ scope.row.status ===
                        0 ? "启用" : "禁用" }}</el-button>
                    <el-button type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination v-if="closetList" layout="prev, pager, next" :current-page="data.currentPage"
            :size="data.pagesize" :total="closetList.total" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
    </div>
</template>
<script setup>
import { ref, onMounted } from 'vue';
import { defineEmits } from 'vue';

import service from '@/utils/request.js'
import { Plus } from '@element-plus/icons-vue'

const handlePreview = () => {
    data.value.currentImageVisible = true
}

const handleRemove = () => {
    data.value.uploadFile = null;
    $('.el-upload').css('display', 'flex');
}

const handleFileChange = (file, newFileList) => {
    data.value.currentImage = newFileList;
    data.value.uploadFile = file.raw;
    if (data.value.currentImage.length > 0) {
        $('.el-upload').css('display', 'none');
    }
};

const closetList = ref({})

const input = ref()
const editInfo = ref({
    age: null,
    sort: null,
    name: null,
    charaId: null,
    diff: null,
    description: null,
    status: 1,
    updateTime: null,
    id: null,
    image: null
})
const originInfo = ref()


const props = defineProps({
    employee: {
        type: Object,
        default: {}
    },
    parentCurrentPage: {
        type: Number
    },
    charaNameList: {
        type: Object
    },
})

const data = ref({
    submit_button_disabled: false,
    loading: false,
    currentPage: 1,
    pagesize: 10,
    editVisible: ref(false),
    createVisible: ref(false),
    deleteVisible: ref(false),
    currentImageVisible: ref(false),
    currentImage: ref([]),
    uploadFile: ref(),
    checkAll: ref(true),
    checkedCharas: ref({}),
    isIndeterminate: ref(false),
});

const checkedClosetInfo = ref()

// const handleCheckAllChange = (value) => {
//     data.value.checkedCharas = value ? Object.keys(props.closet.charaNameList) : [];
//     data.value.isIndeterminate = false;
// };

// const handleCheckedChange = () => {
//     data.value.checkAll = data.value.checkedCharas.length === Object.values(props.closet.charaNameList).length;
//     data.value.isIndeterminate = data.value.checkedCharas.length > 0 && data.value.checkedCharas.length < Object.values(props.closet.charaNameList).length;
//     checkedClosetInfo.value = props.closet.closetInfo.filter(item =>
//         Object.values(data.value.checkedCharas).includes(item.charaId.toString())
//     )
// };

const handleEdit = (id, row) => {
    editInfo.value = JSON.parse(JSON.stringify(row));
    originInfo.value = JSON.parse(JSON.stringify(row));
    data.value.editVisible = true;
}

const handleDelete = (id, row) => {
    editInfo.value = JSON.parse(JSON.stringify(row));
    data.value.deleteVisible = true;
}

const handleCreate = () => {
    data.value.createVisible = true;
    resetEditInfo();
}

const cancel = () => {
    data.value.editVisible = false;
    data.value.createVisible = false;
    data.value.deleteVisible = false;
    resetEditInfo();
}

const submit = async () => {
    if (data.value.editVisible) {
        if (JSON.stringify(editInfo.value) === JSON.stringify(originInfo.value)) {
            data.value.editVisible = false;
        }
        try {
            // 表格校验
            data.loading = true;
            if (data.value.uploadFile) {
                const formData = new FormData();
                formData.append('file', data.value.uploadFile);
                try {
                    const uploadRes = await service.post("/admin/common/upload", formData);
                    if (uploadRes.data != false) {
                        editInfo.value.image = uploadRes.data;
                    }
                }
                catch (error) {
                    console.log(error);
                }
            }

            try {
                const uploadPropertyRes = await service.put("/admin/closet", editInfo.value);
                if (uploadPropertyRes.data != false) {
                    data.loading = false;
                } else {
                    data.loading = false;
                    console.log(error);
                }
            } catch (error) {
                console.log(error);
            }
            data.value.editVisible = false;
            handleRefresh(data.value.currentPage, data.value.pagesize);
        } catch (error) {
            console.log(error);
        }
    } else if (data.value.createVisible) {
        if (data.value.uploadFile) {
            const formData = new FormData();
            formData.append('file', data.value.uploadFile);
            try {
                const uploadRes = await service.post("/admin/common/upload", formData);
                if (uploadRes.data != false) {
                    editInfo.value.image = uploadRes.data;
                }
            }
            catch (error) {
                console.log(error);
            }
        }
        try {
            // 表格校验
            data.loading = true;
            editInfo.value.updateTime = new Date();
            const res = await service.post("/admin/closet", editInfo.value)
            if (res.data != false) {
                handleRefresh(data.value.currentPage, data.value.pagesize);
                data.loading = false;
            } else {
                data.loading = false;
                console.log(error);
            }
            data.value.createVisible = false;
        } catch (error) {
            console.log(error);
        }
    } else if (data.value.deleteVisible) {
        try {
            // 表格校验
            data.loading = true;
            const res = await service.delete("/admin/commission", {
                params: {
                    id: editInfo.value.id
                }
            })
            if (res.data != false) {
                handleRefresh(data.value.currentPage, data.value.pagesize);
                data.loading = false;
            } else {
                data.loading = false;
                console.log(error);
            }
            data.value.deleteVisible = false;
        } catch (error) {
            console.log(error);
        }
    }

}

const handleSearch = async () => {
    try {
        const getKey = (obj, value) => {
            const entry = Object.entries(obj).find(([key, val]) => val === value);
            return entry ? entry[0] : null;
        };
        const id = getKey(props.closet.charaNameList, input.value)
        handleRefresh(data.value.currentPage, data.value.pagesize, id);
    } catch (error) {
        console.log(error);
    }
}

const handleEnable = async (id, row) => {
    try {
        const status = row.status === 1 ? 0 : 1;
        const url = `/admin/closet/status/${status}`;
        const res = await service.post(url, null, {
            params: {
                id: row.id
            }
        });
        if (res.data != false) {
            handleRefresh(data.value.currentPage, data.value.pagesize);
        } else {
            console.log(error);
        }
    } catch (error) {
        console.log(error);
    }
}

const handleCurrentChange = (val) => {
    data.value.currentPage = val;
    handleRefresh(data.value.currentPage, data.value.pagesize);
}

const handleSizeChange = (val) => {
    return
}

const resetEditInfo = () => {
    editInfo.value = {
        age: null,
        sort: null,
        name: null,
        charaId: null,
        diff: null,
        description: null,
        status: 1,
        updateTime: null,
        id: null,
        image: null
    };
    data.value.uploadFile = null;
    // data.value.currentImage = [];
    $('.el-upload').css('display', 'flex');
}


const getClosetList = (currentPage, pagesize, id) => {
    const params = {
        page: currentPage,
        pageSize: pagesize,
        charaId: id
    };
    service.get("/admin/closet/page", { params })
        .then(res => {
            const total = res.data.total;
            const rst = res.data.records;
            if (rst.length != 0 && rst[0] != null) {
                for (let i = 0; i < rst.length; i++) {
                    const images = Object.values(require.context("img", true, /.*/).keys());
                    for (let j = 0; j < images.length; j++) {
                        if (images[j].includes(rst[i].image)) {
                            let q = images[j].replace(/^.\//, '');
                            rst[i].image = require(`img/${q}`);
                        }
                    }
                }
                closetList.value = { closetInfo: rst, total: total, charaNameList: props.charaNameList };
                console.log(closetList)
            } else {
                console.error('返回服设信息为空', error);
            }
        }).catch(error => {
            console.error('获取服设信息失败', error);
        });
}

const handleRefresh = (currentPage, pagesize, id) => {
    getClosetList(currentPage, pagesize, id);
};

onMounted(() => {
    getClosetList(props.parentCurrentPage, data.value.pagesize, null);
})


</script>
<style scoped>
.uploader {
    width: 300px
}
</style>